import { z } from 'zod';

import { MESSAGE } from '@/lib/constants';

export const addCustomerSchema = z.object({
  fullName: z.string().trim().min(1, { message: MESSAGE.REQUIRED_FIELD }),
  email: z
    .string()
    .trim()
    .email({ message: 'Enter a valid email address' })
    .optional()
    .or(z.literal('')),
  phone: z.string().trim().optional(),
  serviceAddress: z.string().trim().optional(),
  notes: z.string().trim().optional(),
});

export type AddCustomerInput = z.infer<typeof addCustomerSchema>;

export const editCustomerSchema = z.object({
  serviceAddress: z.string().trim().optional(),
  notes: z.string().trim().optional(),
  status: z.enum(['active', 'inactive']),
});

export type EditCustomerInput = z.infer<typeof editCustomerSchema>;
